import { createFileRoute, useParams } from "@tanstack/react-router";
import { AssetWorkspaceRecordsTable } from "@/features/assets/components/asset-workspace-records-table";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/assets/$assetId/workspace/records",
)({
	component: AssetWorkspaceRecordsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Record-hosted Asset workspace Records tab — view-only association list.
 * Row open navigates to top-level org Record so that Record becomes the new
 * workspace root (ADO #1564).
 */
function AssetWorkspaceRecordsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/assets/$assetId/workspace/records",
	});

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<AssetWorkspaceRecordsTable
				orgId={params.orgId}
				assetId={params.assetId}
				host="recordRoot"
				syncSearchToUrl={false}
			/>
		</div>
	);
}
